const NoModelSelected = () =>
  <>
    You must select a model.
  </>

export default NoModelSelected
